import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet} from '@angular/router';
import { filter } from 'rxjs';
import { OrganizationService }  from '../../../core/services/organization.service';
import { TopTabItem, TopTabViewComponent } from '../../../shared/components/top-tab-view/top-tab-view';

@Component({
  selector: 'app-admin-panel',
  standalone: true,
  imports: [
    RouterOutlet,
    TopTabViewComponent
  ],
  templateUrl: './admin-panel.html'
})
export class AdminPanelComponent implements OnInit {
  activeTab = 'dashboard';

  operationTabs: TopTabItem[] = [
    { key: 'dashboard', title: 'Dashboard' },
    { key: 'organization', title: 'Organization' },
    { key: 'exam-slot', title: 'Exam Slot' },
    { key: 'student-list', title: 'Student' },
    { key: 'live-monitor', title: 'Live Monitor' },
    { key: 'exam-record', title: 'Exam Record' }
  ];

 constructor(
  private router: Router,
  private organizationService: OrganizationService
) {}

 ngOnInit(): void {

  this.organizationService
    .getOrganizations()
    .subscribe({
      next: (organizations) => {

      },
      error: (error) => {
        console.error(
          'Failed to load organizations:',
          error
        );
      }
    });

  this.updateActiveTab(this.router.url);

  this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: NavigationEnd) => {
      this.updateActiveTab(event.urlAfterRedirects);
    });
}

  onTabSelected(tab: TopTabItem): void {
    this.router.navigate([
      '/admin/admin-panel',
      tab.key
    ]);
  }

   private updateActiveTab(url: string): void {

      const cleanUrl = url.split('?')[0];

      if (
        cleanUrl.includes('/admin/admin-panel/exam-record/')
      ) {
        this.activeTab = 'exam-record';
        return;
      }

    const segments = url
      .split('?')[0]
      .split('/')
      .filter(Boolean);

    const currentRoute = segments[segments.length - 1];

    const matchingTab = this.operationTabs.find(
      tab => tab.key === currentRoute
    );

    this.activeTab = matchingTab?.key ?? 'dashboard';
  }
}
